<template>
  <div class="custom-margin-full-page" v-if="!loading">
    <div class="main-notification" v-if="subscriptions.length">
      <h4 class="mb-2"> اشتراک فعال شما</h4>
      <div v-for="subscription in subscriptions" :key="subscription.id">
        <strong> {{ subscription.title }} </strong>
        <br>
        <p v-html="subscription.subtitle">
        </p>
        <div>
          فعال تا :
          {{ expire }}
        </div>
      </div>
    </div>
    <div class="has-not-subscription" v-else>
      <h3 class="mb-2">شما هیچ اشتراک فعالی ندارید.</h3>
      <v-row>
        <v-col class="text-center normal-button">
          <v-btn @click="$router.push('/dashboard/subscriptions')">
            خرید اشتراک
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardDesktop",
  data() {
    return {
      hasValidSubscription: true,
      expire: null,
      loading: true,
      subscriptions: [],
    }
  },
  methods: {
    getActiveSubscriptions() {
      window.axios.get('student/subscriptions/my', this.course).then((res) => {
        this.subscriptions = res.data.data.subscriptions
        this.expire = res.data.data.expire?.expire_fa
        this.loading = false
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    }
  },
  mounted() {
    this.getActiveSubscriptions()
  }

}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 5vh 6vw 0 2vw;
}

.main-notification {
  padding: 20px !important;
  height: 200px;
  width: 80% !important;
  background-color: rgba(230, 230, 230, 0.65) !important;
  display: table !important;
  margin: auto !important;
  border-radius: 20px !important;
}

.normal-button {
  letter-spacing: normal !important;
}

.has-not-subscription {
  padding: 20px !important;
  height: 200px;
  width: 80% !important;
  background-color: rgba(255, 170, 170, 0.65) !important;
  display: table !important;
  margin: auto !important;
  border-radius: 20px !important;
}
</style>